module.exports = __webpack_public_path__ + "img/yeti.1d0502a8.png";